import _Slider from './Slider';

import './style/index.js';

export * from './type';

export const Slider = _Slider;

export default Slider;
